import { render, staticRenderFns } from "./AddToCartButton.vue?vue&type=template&id=cb68cc8e&scoped=true&"
import script from "./AddToCartButton.vue?vue&type=script&lang=ts&"
export * from "./AddToCartButton.vue?vue&type=script&lang=ts&"
import style0 from "./AddToCartButton.vue?vue&type=style&index=0&id=cb68cc8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb68cc8e",
  null
  
)

component.options.__file = "AddToCartButton.vue"
export default component.exports